<!-- 年月周日筛选 -->
<template lang="html">
	<div>  
        <el-link :type="timeTypeSelf==i.value?'primary':'default'" :underline="false" v-for="(i,index) in arr" :key="index" :label="i.value" @click="handleChange(i.value,'')" style="marginRight:15px;">{{i.label}}</el-link>

        <el-date-picker type="date" v-if="timeTypeSelf=='date'"  v-model="timeDateSelf" :clearable="false" size="small" value-format="yyyy-MM-dd" align="center" @change="handleChange('date',2)" />
        <el-date-picker type="week" v-if="timeTypeSelf=='week'"  v-model="timeDateSelf" :clearable="false" size="small" format='yyyy 第 WW 周' align="center" value-format="yyyy-MM-dd" @change="handleChange('week',2)" />
        <el-date-picker type="month" v-if="timeTypeSelf=='month'"  v-model="timeDateSelf" :clearable="false" size="small" format='yyyy-MM月' align="center" value-format="yyyy-MM-dd" @change="handleChange('month',2)" />
        <el-date-picker type="year" v-if="timeTypeSelf=='year'"  v-model="timeDateSelf" :clearable="false" size="small" format='yyyy年' align="center" value-format="yyyy-MM-dd" @change="handleChange('year',2)"/>
        <el-date-picker type="daterange" v-if="timeTypeSelf=='free'" v-model="timeDateSelf" :clearable="false" size="small" format="yyyy-MM-dd" align="center" value-format="yyyy-MM-dd" @change="handleChange('free',2)" style="width:220px"/>
    </div>
</template>
    

<script>
import moment from 'moment';
export default {
    data() {
        return {
            timeTypeSelf: this.timeType,
            timeDateSelf: this.timeDate,
            arr: [{
                label: '自选',
                value: 'free'
            }, {
                label: '今日',
                value: 'date'
            }, {
                label: '本周',
                value: 'week'
            }, {
                label: '本月',
                value: 'month'
            }, {
                label: '全年',
                value: 'year'
            }, {
                label: '全部',
                value: 'all'
            }],
        }
    },
    props: {
        timeType: {
            type: String,
           
        },
        timeDate: {
            type: [String,Array],
            
        }
    },
    methods: {
        handleChange(value, types) {
            this.timeTypeSelf = value;

            if (types != 2) { //按钮change
                let zhi;
                if (value == 'date') {
                    zhi = moment().format("YYYY-MM-DD")
                    console.log(zhi);
                } else if (value == 'week') {
                    zhi = moment().isoWeekday(1).format("YYYY-MM-DD")
                } else if (value == 'month') {
                    zhi = moment().startOf('month').format("YYYY-MM-DD")
                } else if (value == 'year') {
                    zhi = moment().startOf('year').format("YYYY-MM-DD")
                } else if (value == 'all') {
                    zhi = '';
                } else if (value == 'free') {
                    zhi = [moment().startOf('month').format("YYYY-MM-DD"), moment().endOf('month').format("YYYY-MM-DD")]
                }

                this.timeDateSelf = zhi;
            }

            this.$emit('success', this.timeTypeSelf, this.timeDateSelf);
        }
    },
}
</script>